// Fragment "pricingFix" — clés ajoutées par le correctif W2a des éditeurs de prix
// (ProductsAdmin.jsx / ProgramsAdmin.jsx) : sélecteur de devise, jusqu'ici absent
// alors que "cad" était codé en dur malgré le champ "currency" affiché en lecture.
// Les libellés "shop.price" / "programs.editor.price" existants ont été réécrits
// en place (base.js / strays.js) pour refléter la saisie en dollars désormais
// utilisée par l'éditeur — le champ number était auparavant lié DIRECTEMENT à
// price_cents (un cents), source d'erreurs de facturation ×100.
// BUG-212 — FIXED 2026-09-11: `legacyNotice` / `switch` used to say "this platform now
// charges in {settlement}", which was true under the retired one-settlement-currency
// catalogue but is false under the shipped presentment model (`tenants.currency`,
// docs/payment-module/multi-currency-implementation-plan.md): the mismatch this notice
// reports is between the catalogue ROW and the PRACTICE's own operating currency, never
// the platform's, so a CAD practice holding a stranded USD row was told the PLATFORM had
// changed currency — false, and blaming the wrong party. The interpolation variable is
// renamed `settlement` → `denomination` to match, mirroring the same rename in
// CatalogueCurrencyField.jsx and booking/service.py.
export default {
  fr: {
    "shop.currency": "Devise",
    "programs.editor.currency": "Devise",
    "catalogue.currency.legacyNotice": "Tarifé en {held}. Votre pratique facture désormais en {denomination} : cet article ne peut pas être acheté en ligne tant qu'il n'est pas retarifé.",
    "catalogue.currency.switch": "Passer en {denomination}",
    "catalogue.currency.notPayable": "Non payable en ligne ({held})",
  },
  en: {
    "shop.currency": "Currency",
    "programs.editor.currency": "Currency",
    "catalogue.currency.legacyNotice": "Priced in {held}. Your practice now charges in {denomination}, so this item cannot be bought online until it is repriced.",
    "catalogue.currency.switch": "Switch to {denomination}",
    "catalogue.currency.notPayable": "Not payable online ({held})",
  },
  es: {
    "shop.currency": "Moneda",
    "programs.editor.currency": "Moneda",
    "catalogue.currency.legacyNotice": "Con precio en {held}. Su práctica ahora cobra en {denomination}, por lo que este artículo no se puede comprar en línea hasta que se vuelva a tarifar.",
    "catalogue.currency.switch": "Cambiar a {denomination}",
    "catalogue.currency.notPayable": "No pagable en línea ({held})",
  },
};
